import EF from 'ef/ef';
import LocaleService from 'services/loader-handler-services/locale-service';
import Chaplin from 'chaplin';
import QuestionsCollection from 'ef/collections/assessments/questions_collection';
import Attempt from 'ef/models/assessments/attempt';
import $ from 'jquery';
import _ from 'lodash';

const Assessment = Chaplin.Model.extend({
  initialize: function () {
    _.bindAll(this, 'assessmentLoaded', 'assessmentLoadFailed', 'loadLocal');
  },
  url: function (isSaving) {
    return EF.ContentProvider.AssessmentService.getUrl(this, isSaving);
  },

  loadAssessment: function (options) {
    this.options = options;
    if (EF.options.local) {
      return this.loadLocal();
    } else {
      const onFail = options.failToLocal ? this.loadLocal : this.assessmentLoadFailed;
      return this.fetch(options).done(this.assessmentLoaded).fail(onFail);
    }
  },

  loadLocal: function () {
    const deferred = $.Deferred();
    deferred.done(this.assessmentLoaded);
    deferred.fail(this.assessmentLoadFailed);
    try {
      import(`/local-data/assessments/${this.get('slug')}`)
        .then(localData => {
          if (!localData.questions) {
            localData.questions = [];
          }
          if (localData.sections) {
            const sectionQuestions = localData.sections.reduce((result, section) => {
              return result.concat(section.questions);
            }, []);
            localData.questions = localData.questions.concat(sectionQuestions);
          }
          localData.questions.forEach(function (question) {
            if (typeof question.text !== 'string') {
              question.text = question.text[LocaleService.getLanguage()];
            }
            question.id = String(question.id);
            if (!question.correct_answer && question.correct_answers && question.correct_answers.length === 1) {
              question.correct_answer = question.correct_answers[0];
            }
            question.answers.forEach(function (answer) {
              if (typeof answer.text !== 'string') {
                answer.text = answer.text[LocaleService.getLanguage()];
              }
            });
          });
          this.set('local', true);
          deferred.resolve(localData);
        })
        .catch(() => {
          throw Error('LoadLocal error, failed importing');
        });
    } catch (e) {
      deferred.reject();
    }
    return deferred;
  },

  assessmentLoaded: function (assessment) {
    this.set('questions', new QuestionsCollection(assessment.questions));
    if (this.options.split_questions) {
      this.set('original_questions', new QuestionsCollection(assessment.questions));
    }
    this.set(
      'attempt',
      new Attempt(assessment.attempt, {
        assessment: this,
      })
    );
    let passing_grade = this.get('passing_grade') ?? assessment.passing_grade;
    if (this.get('must_pass')) {
      passing_grade = passing_grade ?? 100;
    }
    this.set('passing_grade', passing_grade);
    this.trigger('assessments:load', this);
    EF.trigger('assessments:load', this);
  },

  assessmentLoadFailed: function () {
    this.trigger('assessments:load:failure');
    EF.trigger('assessments:load:failure');
  },

  filterQuestions: function (count, start) {
    start = start ? start - 1 : 0;
    const questions = this.get('questions').slice(start, start + count);
    this.set('questions', new QuestionsCollection(questions));
  },
});

export default Assessment;
